import React from "react";
import { Loader2 } from "lucide-react";

interface LoadingSpinnerProps {
  size?: number;
  className?: string;
  fullScreen?: boolean;
}

export function LoadingSpinner({
  size = 32,
  className = "",
  fullScreen = false,
}: LoadingSpinnerProps) {
  const spinner = (
    <Loader2
      size={size}
      className={`animate-spin text-secondary-400 ${className}`}
    />
  );

  if (fullScreen) {
    return (
      <div className='fixed inset-0 flex items-center justify-center bg-white z-50'>
        {spinner}
      </div>
    );
  }

  return <div className='flex items-center justify-center p-8'>{spinner}</div>;
}
